import React from 'react';
import { ShopSection } from '../../components/organisms/ShopSection/ShopSection';
import { sectionConfigs } from '../../utils/constants';

export const Children = () => <ShopSection config={sectionConfigs.children} />;
